import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDebounceFn } from 'ahooks';

import { useNECaptcha } from '@yaotai/common-utils';
import { Button, Form } from '@fuxi/eevee-ui';
import { SubmitSuccess } from '@portalCommon/components/SubmitSuccess';
import { reportContactCommitFrom, trimStr } from '@portalCommon/utils';

import classnames from 'classnames/bind';
import ContactFormItems from '@/components/ContactFormItems';
import API from '@/services';

import styles from './index.module.less';

const cx = classnames.bind(styles);

const BUTTON_LAYOUT = {
  wrapperCol: { span: 24, offset: 9 },
};

export default function AgentApply({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isContactSuccess, setIsContactSuccess] = useState<boolean | undefined>();
  const { captchaIns, getCaptchaIns } = useNECaptcha({
    mode: 'bind',
    element: '#captcha_agent',
    onVerify: function (err: any, data: any) {
      if (err) return;
      handleFinish(data.validate);
    },
  });

  const getBody = (values: any) => {
    return {
      user_info: {
        name: trimStr(values.name),
        phone: `+${values?.phone?.code}${values?.phone?.phone}`,
        orga_name: trimStr(values.orga_name),
        title: trimStr(values.title),
        from_url: window.location.href,
      },
      extends_json: {
        content: [3, values.agentContent],
      },
      source: 'agent',
    };
  };

  const handleFinish = async (validate: string) => {
    const values = await form.validateFields();
    const body = getBody(values);
    try {
      await API.contact.contact({ ...body, validate });
      setIsContactSuccess(true);
      reportContactCommitFrom();
    } catch (err) {
      setIsContactSuccess(false);
      getCaptchaIns()?.refresh();
    }
  };
  const handleCaptcha = async () => {
    await form.validateFields();
    captchaIns?.verify();
  };
  const { run } = useDebounceFn(
    () => {
      handleCaptcha?.();
    },
    {
      wait: 500,
    },
  );
  return (
    <>
      {isContactSuccess ? (
        <SubmitSuccess />
      ) : (
        <div className={cx('form-wrapper', className)}>
          <Form layout="vertical" form={form}>
            <ContactFormItems isAgent={true} form={form} isContactSuccess={isContactSuccess} />
            <Form.Item {...BUTTON_LAYOUT}>
              <div id="captcha_agent"></div>
              <Button onClick={run} style={{ width: 220, height: 48, fontSize: 16, fontWeight: 400, marginTop: 40 }}>
                {t('agentApply.btn')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </>
  );
}
